<template>
  <b-modal
    id="addModalDetails"
    centered
    :title="$t('details_leftovers')"
    size="lg"
    :hide-footer="true"
    :cancel-title="$t('general.cancel')"
  >
    <!-- {{ GET_ISNTRUMENTS_MODAL_DETAIL }} -->
    <b-table
      :fields="fields"
      :items="card ? GET_MODAL_DETAILS : GET_ISNTRUMENTS_MODAL_DETAIL"
      show-empty
      responsive
      hover
      :empty-text="$t('empty_text')"
    >
      <template #head()="props">
        <span>{{ $t(props.label) }}</span>
      </template>

      <template #cell(is_main)="data">
        <b-form-group>
          <b-form-checkbox
            :checked="data.item.is_main"
            class="mr-0 mt-50"
            name="is-rtl"
            switch
            inline
            disabled
          />
        </b-form-group>
      </template>

      <template #cell(sum_remainder)="props">
        <span>{{ $_formatPriceMixin(props.item.sum_remainder) }}</span>
      </template>
      
      <template #cell(actions)="props">
        <b-button
          :title="$t('watch')"
          size="sm"
          variant="primary"
          class="mt-50 mb-50"
          @click="showDetailsAboutIncomesModal(props.item)"
        >
          <feather-icon icon="EyeIcon" size="15" />
        </b-button>
      </template>
      
    </b-table>

    <seeProductsModal :seeProducts="seeProducts"></seeProductsModal>
  </b-modal>
</template>

<script>
import {
  BModal,
  BFormGroup,
  BFormInput,
  BTable,
  BButton,
  BFormCheckbox,
} from "bootstrap-vue";
import { mapGetters } from "vuex";
import priceFormatMixin from "@/mixins/priceFormatMixin";
import seeProductsModal from './seeProductsModal.vue'
export default {
  components: {
    BModal,
    BFormGroup,
    BFormCheckbox,
    BFormInput,
    BTable,
    BButton,
    seeProductsModal
  },
  props: {
    card: {
      type: Boolean,
    },
  },
  mixins: [priceFormatMixin],
  data() {
    return {
      fields: [
        {
          label: "№",
          key: "storage_id",
        },

        {
          label: "reference.name",
          key: "storage__title",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "main",
          key: "is_main",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "sum_amount",
          key: "sum_remainder",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "actions",
          key: "actions",
          thClass: "text-center",
          tdClass: "text-center",
        },
      ],
      seeProducts: []
    };
  },
  computed: {
    ...mapGetters("materials", ["GET_MODAL_DETAILS"]),
    ...mapGetters("instruments", ["GET_ISNTRUMENTS_MODAL_DETAIL"]),
  },
  methods: {
    showDetailsAboutIncomesModal(item){
      this.seeProducts = item.requirements
      this.$bvModal.show('seeProductsModal')
    }
  }
};
</script>

<style>
</style>
